import { DetectionError } from './errors'
import { type SourceFormat } from './models'
import { PARSERS } from './parsers'

export function detectFormat(data: string): SourceFormat {
  if (data.includes('# Netscape HTTP Cookie File')) {
    return 'netscape'
  }

  if (data.includes('\n\n')) {
    const lower = data.toLowerCase()
    if (lower.includes('2fa:') && lower.includes('cookies:') && !data.includes('2FA key:')) {
      return 'full_format'
    }
    if (data.includes('Cookies Json:') || data.includes('2FA key:')) {
      return 'web_blocks'
    }
  }

  for (const raw of data.trim().split('\n')) {
    const line = raw.trim()
    if (!line) continue
    if (line.includes('[') && line.includes(']')) {
      const before = line.split('[')[0]
      const colons = (before.match(/:/g) ?? []).length
      if (colons === 1) return 'web_json'
      if (colons >= 2) return 'web_cookies'
    }
    const parts = line.split('|')
    if (parts.length >= 4 && (parts[3].includes('Bearer') || parts[3].includes('Authorization'))) {
      return 'mobile'
    }
    break
  }

  for (const [name, p] of Object.entries(PARSERS)) {
    if (p.canParse(data)) return name as SourceFormat
  }
  throw new DetectionError('Cannot detect input format')
}
